class DatiGNSSVektor {
    constructor(pnt1, pnt2) {
        this.pnt1 = pnt1;
        this.pnt2 = pnt2;
    }
}

export { DatiGNSSVektor as default }